<template>
  <v-card class="recorder credit-card card--flex--toolbar">
    <v-card-title class="grey lighten-3 pt-0">
      <v-toolbar flat class="transparent">
        <v-toolbar-title>個別指導</v-toolbar-title>
        <template v-slot:extension class="px-0">
          <v-row dense>
            <v-col cols="12" class="mt-5">
              <v-autocomplete validate-on-blur hide-details
                ref="searcher"
                v-model="form.cid"
                color="primary"
                label="関連する顧客"
                :no-data-text="printNoDataText"
                :readonly="isSetClient"
                :items="getClientItems"
                :loading="isSearching"
                :search-input.sync="form.search"
                :rules="rules.required"
              />
            </v-col>
          </v-row>
        </template>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="pt-3">
      <v-form lazy-validation ref="form" v-model="form.valid">
        <v-row dense v-if="form.cid" align="center" justify="center">
          <v-col cols="12">
            <v-menu offset-y
              v-model="config.datepicker.lesson"
              transition="scale-transition"
              min-width="290px"
              :close-on-content-click="false"
              :nudge-right="40">
              <template v-slot:activator="{ on }">
                <v-text-field readonly validate-on-blur
                  v-on="on"
                  v-model="printFormDate"
                  color="primary"
                  label="授業日"
                  :rules="rules.required"
                  :append-icon="form.date ? 'fal fa-times' : null"
                  @click:append="form.date = ''"
                />
              </template>
              <v-date-picker
                v-model="form.date"
                locale="ja"
                color="amber"
                :day-format="date => new Date(date).getUTCDate()"
                @input="config.datepicker.lesson = false"
              />
            </v-menu>
          </v-col>
          <v-col cols="12">
            <p class="catpion mb-2">担当者</p>
            <v-chip-group column
              active-class="secondary white--text"
              v-model="form.tutor"
              :rules="rules.required">
              <v-chip
                v-for="item in getTutorItems"
                :key="`tutor_${item.value}`"
                :value="item.value"
                :rules="rules.required">{{ item.text }}</v-chip>
            </v-chip-group>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="form.attend"
              label="出席状況"
              color="primary"
              :items="getAttendItems"
              :rules="rules.required"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.lesson.start"
              v-mask="'##:##'"
              label="開始時刻"
              append-icon="fal fa-clock"
              :rules="rules.required"
              @click:append="timepick({ name: 'lesson', type: 'start' })"
              @blur="verifyTime({ name: 'lesson', type: 'start' })"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.lesson.end"
              v-mask="'##:##'"
              label="終了時刻"
              append-icon="fal fa-clock"
              :rules="rules.required"
              @click:append="timepick({ name: 'lesson', type: 'end' })"
              @blur="verifyTime({ name: 'lesson', type: 'end' })"
            />
          </v-col>
          <v-dialog v-model="config.timepicker.lesson.status" max-width="290">
            <v-time-picker
              v-model="config.timepicker.lesson.input"
              ref="lessonTimepicker"
              format="24hr"
              :min="getLessonTimeMin">
              <v-spacer></v-spacer>
              <v-btn text color="secondary" @click.stop="timepicked">決定する</v-btn>
            </v-time-picker>
          </v-dialog>
          <v-col cols="12">
            <v-text-field
              v-model="form.wage"
              label="時給発生時間"
              suffix="時間"
              :hint="'1時間30分=1.5、1時間45分=1.75'"
              @blur="verifyWage({ format: true })"
              @focus="verifyWage({ format: false })"
            />
          </v-col>
          <v-col cols="12">
            <v-combobox
              v-model="form.subject"
              label="科目"
              color="primary"
              :items="getSubjectItems"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.topic"
              label="授業内容"
              hint="簡潔にお願いします"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.comment"
              label="担当者コメント"
              counter="300"
            />
          </v-col>
          <v-col cols="12">
            <p class="catpion mb-2">次回予定</p>
            <v-btn-toggle mandatory dense
              v-model="form.reserve.status"
              class="transparent"
              :rules="rules.required">
              <v-btn :color="form.reserve.status === '未定' ? 'secondary white--text' : 'blue-grey lighten-4'" value="未定">未定</v-btn>
              <v-btn :color="form.reserve.status === '予約' ? 'secondary white--text' : 'blue-grey lighten-4'" value="予約">予約</v-btn>
            </v-btn-toggle>
          </v-col>
          <template v-if="form.reserve.status === '予約'">
            <v-row dense>
              <v-col cols="12">
                <v-menu offset-y
                  v-model="config.datepicker.reserve"
                  transition="scale-transition"
                  min-width="290px"
                  :close-on-content-click="false"
                  :nudge-right="40">
                  <template v-slot:activator="{ on }">
                    <v-text-field readonly validate-on-blur
                      v-on="on"
                      v-model="printFormReserveDate"
                      color="primary"
                      label="予約日"
                      :append-icon="form.reserve.date ? 'fal fa-times' : null"
                      @click:append="form.reserve.date = ''"
                    />
                  </template>
                  <v-date-picker
                    v-model="form.reserve.date"
                    locale="ja"
                    color="amber"
                    :day-format="date => new Date(date).getUTCDate()"
                    @input="config.datepicker.reserve = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.reserve.start"
                  v-mask="'##:##'"
                  label="開始時刻"
                  append-icon="fal fa-clock"
                  :rules="rules.required"
                  @click:append="timepick({ name: 'reserve', type: 'start' })"
                  @blur="verifyTime({ name: 'reserve', type: 'start' })"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.reserve.end"
                  v-mask="'##:##'"
                  label="終了時刻"
                  append-icon="fal fa-clock"
                  :rules="rules.required"
                  @click:append="timepick({ name: 'reserve', type: 'end' })"
                  @blur="verifyTime({ name: 'reserve', type: 'end' })"
                />
              </v-col>
              <v-dialog v-model="config.timepicker.reserve.status" max-width="290">
                <v-time-picker
                  v-model="config.timepicker.reserve.input"
                  ref="reserveTimepicker"
                  format="24hr"
                  :min="getReserveTimeMin">
                  <v-spacer></v-spacer>
                  <v-btn text color="secondary" @click.stop="timepicked">決定する</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-row>
          </template>
          <v-col cols="12">
            <v-text-field
              v-model="form.note"
              label="備考欄"
              color="primary"
              counter="50"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text
        color="secondary"
        @click="close">閉じる</v-btn>
      <v-spacer></v-spacer>
      <v-btn depressed
        color="secondary"
        :loading="isLoading"
        :disabled="!isValid"
        @click="post">
        {{ isSetId ? '更新する' : '投稿する' }}
      </v-btn>
    </v-card-actions>
    <Confirmer ref="confirmer" />
  </v-card>
</template>

<script>
import _ from 'lodash'
import { mask } from 'vue-the-mask'
import Confirmer from '@/components/modals/confirm'
export default {
  name: 'recorderTutor',
  directives: { mask },
  props: [ 'client' ],
  components: {
    Confirmer
  },
  data () {
    return {
      config: {
        status: {
          loading: false,
          searching: false
        },
        datepicker: {
          lesson: false,
          reserve: false
        },
        timepicker: {
          lesson: {
            status: false,
            type: '',
            input: ''
          },
          reserve: {
            status: false,
            type: '',
            input: ''
          }
        }
      },
      meta: {
        attends: [
          '出席',
          '遅刻（連絡有：遅刻分時給発生なし）',
          '遅刻（連絡無：遅刻分時給発生）',
          '遅刻（連絡有：遅刻分時給発生）',
          '欠席（連絡有：欠席分時給発生なし）',
          '欠席（連絡無：欠席分時給発生）',
          '欠席（連絡有：欠席分時給発生）'
        ],
        subjects: [
          '入試対策',
          '英語',
          '代々木レポート',
          '小論文',
          '漢字',
          '韓国語',
          '数学'
        ]
      },
      store: {
        clients: []
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ],
        array: {
          required: [
            v => !!v.length || '必須項目'
          ]
        }
      },
      form: {
        valid: true,
        id: '',
        cid: '',
        date: this.$moment().format('YYYY-MM-DD'),
        tutor: '',
        attend: '',
        lesson: {
          start: '',
          end: ''
        },
        wage: '',
        subject: '',
        topic: '',
        comment: '',
        reserve: {
          status: '',
          date: '',
          start: '',
          end: ''
        },
        note: '',
        search: ''
      }
    }
  },
  methods: {
    init: function (req) {
      const { id, cid, date, content } = req || {}
      const { tutor, attend, lesson, wage, subject, topic, comment, reserve, note } = content ? JSON.parse(content) : {}
      this.$set(this.config, 'status', {
        loading: false,
        searching: false
      })
      this.$set(this, 'form', {
        valid: true,
        id: id || '',
        cid: cid || this.$route.params.id || '',
        date: date || this.$moment().format('YYYY-MM-DD'),
        tutor: tutor || '',
        attend: attend || '',
        lesson: {
          start: (lesson && lesson.start) ? lesson.start : '',
          end: (lesson && lesson.end) ? lesson.end : ''
        },
        wage: wage || '',
        subject: subject || '',
        topic: topic || '',
        comment: comment || '',
        reserve: {
          status: (reserve && reserve.status) ? reserve.status : '',
          date: (reserve && reserve.date) ? reserve.date : '',
          start: (reserve && reserve.start) ? reserve.start : '',
          end: (reserve && reserve.end) ? reserve.end : ''
        },
        note: note || '',
        search: ''
      })
      if (this.$route.params.id) {
        const name = this.$store.getters['client/get']('name').join(',')
        const kana = this.$store.getters['client/get']('kana').join(',')
        this.$set(this.store, 'clients', [{
          id: this.$route.params.id,
          name,
          kana
        }])
      }
    },
    close: function () {
      this.$emit('close')
    },
    post: function () {
      this.submit({ type: !this.form.id ? 'insert' : 'update' })
    },
    remove: function () {
      this.$refs.confirmer.open({
        message: 'この投稿を削除してもよろしいですか？',
        callback: () => {
          this.submit({ type: 'remove' })
        }
      })
    },
    timepick: function (req) {
      const { name, type } = req || {}
      if (this.form[name][type] != null) {
        this.$set(this.config.timepicker, name, {
          type,
          input: this.form[name][type] || null,
          status: true
        })
      }
    },
    timepicked: function (e) {
      const { timepicker } = this.config
      const name = timepicker.lesson.status ? 'lesson' : 'reserve'
      const { type, input } = timepicker[name]
      if (this.form[name][type] != null) {
        this.$set(this.form[name], type, input)
        this.config.timepicker[name].status = false
        this.verifyTime({ name, type })
      }
    },
    verifyTime: function (req) {
      const { name, type } = req || {}
      const date = this.$moment().format('YYYY-MM-DD')
      const { start, end } = this.form[name]
      if (type === 'start') {
        if (start && this.$moment(`${date} ${start}`).isValid()) {
          if (this.$moment(`${date} ${start}`).isAfter(`${date} ${end}`)) {
            this.$set(this.form[name], 'end', this.$moment(`${date} ${start}`).add(1, 'hours').format('HH:mm'))
          }
        } else {
          this.$set(this.form[name], 'start', this.$moment(`${date} ${end}`).subtract(1, 'hours').format('HH:mm'))
        }
        this.$nextTick(() => {
          this.$set(this.form[name], 'start', this.$moment(`${date} ${this.form[name].start}`).format('HH:mm'))
        })
      } else if (type === 'end') {
        if (end && this.$moment(`${date} ${end}`).isValid()) {
          if (this.$moment(`${date} ${end}`).isBefore(`${date} ${start}`)) {
            this.$set(this.form[name], 'start', this.$moment(`${date} ${end}`).subtract(1, 'hours').format('HH:mm'))
          }
        } else {
          this.$set(this.form[name], 'end', this.$moment(`${date} ${start}`).add(1, 'hours').format('HH:mm'))
        }
        this.$nextTick(() => {
          this.$set(this.form[name], 'end', this.$moment(`${date} ${this.form[name].end}`).format('HH:mm'))
        })
      }
    },
    verifyWage: function (req) {
      const { format } = req
      // eslint-disable-next-line
      const { wage } = { wage: this.form.wage ? this.form.wage.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      }) : '0.00' }
      if (format) {
        this.$set(this.form, 'wage', isFinite(wage) ? `${parseFloat(wage).toFixed(2)}`.replace(/0+$/g, '').replace(/\.$/g, '') : '0')
      } else {
        this.$set(this.form, 'wage', parseInt(wage) === 0 ? '' : wage)
      }
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { id, cid, date, tutor, attend, lesson, wage, subject, topic, comment, reserve, note, search } = this.form
      const aid = this.$store.getters['author/get']('userid')
      const developer = this.$store.getters['author/get']('roles').includes('developer')
      const urls = {
        insert: `${this.$url.api}posts/insert/tutor/${cid}`,
        update: `${this.$url.api}posts/update/tutor/${id}`,
        remove: `${this.$url.api}posts/remove/tutor/${id}`,
        client: `${this.$url.api}client/get/items`,
      }
      const fds = {
        insert: { aid, date, tutor, attend, lesson, wage, subject, topic, comment, reserve, note },
        update: { cid, aid, date, tutor, attend, lesson, wage, subject, topic, comment, reserve, note },
        remove: { cid, aid, type: 'tutor' },
        client: { name: search }
      }
      if (type && urls[type] && fds[type]) {
        if ([ 'insert', 'update' ].includes(type)) {
          const url = urls[type]
          const fd = fds[type]
          if (this.$refs.form.validate()) {
            this.$set(this.config.status, 'loading', true)
            return { url, fd, type }
          } else {
            return false
          }
        } else if (type === 'client' && search) {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, postType) {
      const socket = this.$store.getters['config/get']('socket')
      const type = postType || ''
      if (type === 'client') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store, 'clients', req)
      } else {
        if (!socket.connected) {
          socket.connect()
        }
        socket.emit('POST_POST_TUTOR', req, (res) => {
          console.log(res)
          this.$emit('done', req)
          this.init()
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    searchClient: _.debounce(function (val) {
      this.submit({ type: 'client' })
    }, 300),
  },
  watch: {
    'form.search': function (newVal, oldVal) {
      if (!this.$route.params.id) {
        if (newVal && oldVal && newVal.length < oldVal.length) {
          this.$set(this.store, 'clients', [])
        }
        if (!this.config.status.searching && !this.store.clients.length) {
          this.searchClient()
        }
      }
    },
    'config.timepicker.lesson.status': function (val) {
      val && setTimeout(() => { this.$refs.lessonTimepicker.selecting = 1 })
    },
    'config.timepicker.reserve.status': function (val) {
      val && setTimeout(() => { this.$refs.reserveTimepicker.selecting = 1 })
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    isSetId () {
      return this.form.id
    },
    isLink () {
      return this.form.link
    },
    isSetClient () {
      return !!this.$route.params.id
    },
    printNoDataText () {
      return this.form.search ? '検索結果0件です' : 'ふりがな or 名前を入力してください'
    },
    printClientName () {
      return this.$store.getters['client/get']('name').join(' ')
    },
    printFormDate () {
      return this.form.date ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    },
    printFormReserveDate () {
      return this.form.reserve.date ? this.$moment(this.form.reserve.date).format('YYYY/MM/DD') : ''
    },
    getPaymentItems () {
      return this.meta.items
    },
    getLessonTimeMin () {
      const { type } = this.config.timepicker.lesson
      if (type === 'start') {
        return null
      } else {
        return this.form.lesson.start
      }
    },
    getReserveTimeMin () {
      const { type } = this.config.timepicker.reserve
      if (type === 'start') {
        return null
      } else {
        return this.form.reserve.start
      }
    },
    getAttendItems () {
      return this.meta.attends
    },
    getSubjectItems () {
      return this.meta.subjects
    },
    getClientItems () {
      return this.store.clients.length ? this.store.clients.map(it => {
        return {
          text: `${it.name.replace(',', '')}（${it.kana.replace(',', '')}）`,
          value: it.id
        }
      }) : []
    },
    getTutorItems () {
      const authors = this.$store.getters['config/get']('authors')
      const keys = Object.keys(authors)
      return keys.filter(key => { return authors[key].roles.includes('tutor') }).map(key => {
        return {
          text: authors[key].name[0],
          value: authors[key].name[0]
        }
      })
    }
  }
}
</script>